'use client';

import { useAuthContext } from '@/components/AuthProvider';

const CIS_COUNTRIES = ['RU', 'UA', 'AZ', 'AM', 'BY', 'KZ', 'KG', 'MD', 'TJ', 'UZ', 'IL', 'GE', 'TM', 'MN'];

export function useServerIp() {
  const { regionData } = useAuthContext();

  const isLoading = !regionData;
  const countryCode = regionData?.countryCode;
  
  const isCisRegion = CIS_COUNTRIES.includes(countryCode || '');

  const javaIp = isLoading ? '' : (isCisRegion ? 'rp.royolands.com' : 'play.royolands.com');
  const bedrockIp = isLoading ? '' : 'bedrockrp.royolands.com';
  
  const showBedrock = isLoading ? false : isCisRegion;

  return {
    javaIp,
    bedrockIp,
    showBedrock,
    isCisRegion,
    countryCode,
    isLoading
  };
}